<template>
  <b-modal id="modal-advertising" hide-footer>
    <template #modal-header>
      <h4>
        {{
          data.id === null ? $t("advertisings.new") : $t("advertisings.edit")
        }}
      </h4>
    </template>
    <ValidationObserver v-slot="{ handleSubmit }">
      <form @submit.prevent="handleSubmit(onSubmit)">
        <div class="new-user-info">
          <b-row align-h="center">
            <b-col sm="12">
              <div class="text-center mb-4" style="cursor: pointer">
                <b-img
                  class="mt-2 avatar"
                  id="pick-image"
                  style="max-width: 250px"
                  :src="
                    preview
                      ? preview
                      : require('@/assets/images/logo/placeholder.png')
                  "
                ></b-img>
                <br />
                <label class="mt-1 pr-1">Cargar imagen</label>
                <avatar-cropper
                  :upload-handler="selectedFile"
                  @changed="setFileName"
                  trigger="#pick-image"
                  :labels="{
                    submit: $t('app.accept'),
                    cancel: $t('app.cancel'),
                  }"
                  :cropper-options="{
                    aspectRatio: 0,
                    autoCropArea: 1,
                    viewMode: 1,
                    movable: true,
                    zoomable: true,
                  }"
                />
              </div>
            </b-col>
            <b-col md="12">
              <b-row align-v="center">
                <!-- NAME -->
                <b-form-group
                  class="col-md-12"
                  :label="$t('advertisings.name')"
                  label-for="name"
                >
                  <ValidationProvider
                    :name="$t('advertisings.name')"
                    rules="required"
                    v-slot="{ errors }"
                  >
                    <b-form-input
                      v-model="data.name"
                      type="text"
                      :placeholder="$t('advertisings.name-placeholder')"
                      :class="errors.length > 0 ? ' is-invalid' : ''"
                    >
                    </b-form-input>
                    <div class="invalid-feedback">
                      <span>{{ errors[0] }}</span>
                    </div>
                  </ValidationProvider>
                </b-form-group>
              </b-row>
            </b-col>
            <b-col md="12" sm="12">
              <b-row align-v="center">
                <!-- URL -->
                <b-form-group
                  class="col-md-12"
                  :label="$t('advertisings.url')"
                  label-for="url"
                >
                  <ValidationProvider
                    :busines-name="$t('advertisings.url')"
                    rules="required"
                    v-slot="{ errors }"
                  >
                    <b-form-input
                      v-model="data.url"
                      type="text"
                      :placeholder="$t('advertisings.url-placeholder')"
                      :class="errors.length > 0 ? ' is-invalid' : ''"
                    >
                    </b-form-input>
                    <div class="invalid-feedback">
                      <span>{{ errors[0] }}</span>
                    </div>
                  </ValidationProvider>
                </b-form-group>
              </b-row>
            </b-col>
          </b-row>
          <hr />
          <b-button
            class="float-right"
            :disabled="advertisingsLoading"
            variant="success"
            type="submit"
          >
            <span v-if="advertisingsLoading">
              <b-spinner small type="grow"></b-spinner>
              {{ $t("app.loading") }}...
            </span>
            <span v-else>
              {{ $t("app.save") }}
            </span>
          </b-button>
          <b-button
            class="float-right mr-1"
            @click="$bvModal.hide('modal-advertising')"
            variant="outline-danger"
            type="reset"
          >
            {{ $t("app.cancel") }}
          </b-button>
        </div>
      </form>
    </ValidationObserver>
  </b-modal>
</template>
<script>
import { core } from "@/config/pluginInit";
import { mapActions, mapGetters } from "vuex";
import AvatarCropper from "vue-avatar-cropper";
export default {
  name: "CreateOrUpdateAdvertising",
  components: {
    AvatarCropper,
  },
  mounted() {
    core.index();
  },
  data() {
    return {
      fileSelected: null,
      preview: "",
      data: {
        id: null,
        name: null,
        url: null,
        image: null,
      },
    };
  },
  methods: {
    ...mapActions({
      saveForm: "createOrUpdateAdvertising",
    }),
    async show(item) {
      this.reserForm();
      if (item) {
        this.preview = item.image;
        this.data = {
          id: item.id,
          name: item.name,
          url: item.url,
        };
      }
      this.$bvModal.show("modal-advertising");
    },
    setFileName(file) {
      this.fileSelected = file;
      this.data.image = file;
    },
    async selectedFile(cropper) {
      const dataUrl = cropper
        .getCroppedCanvas()
        .toDataURL(this.fileSelected.type);
      const file = core.dataURLtoFile(dataUrl, this.fileSelected.name);
      this.preview = dataUrl;
      this.data.image = file;
    },
    async onSubmit() {
      const resp = await this.saveForm({
        ...this.data,
        ad_contract_id: this.$route.params.id,
      });
      this.$bvModal.hide("modal-advertising");
      this.$emit("refresh");
      if (resp?.status === 201 || resp?.status === 200) {
        core.showSnackbar(
          "success",
          !this.data.id
            ? this.$t("advertisings.success-created")
            : this.$t("advertisings.success-edit")
        );
      }
      this.reserForm();
    },
    reserForm() {
      this.preview = null;
      this.fileSelected = null;
      this.data = {
        id: null,
        name: null,
        url: null,
        image: null,
      };
    },
  },
  computed: {
    ...mapGetters({
      advertisingsLoading: "advertisingsLoading",
    }),
  },
};
</script>
